import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mt-2 text-caption" }

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAllGeoGuesserIds } from '@/services/geoGuesser/geoGuesser.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeoGuesser',
  setup(__props) {

const router = useRouter();
const ids = ref<number[]>([]);
const solvedIds = ref<number[]>([]);

function loadSolved() {
  try {
    solvedIds.value = JSON.parse(localStorage.getItem('geo-guesser-solved') || '[]');
  } catch {
    solvedIds.value = [];
  }
}

function isSolved(id: number) {
  return solvedIds.value.includes(id);
}

function openGuess(id: number) {
  router.push(`/geoguesser/${id}`);
}

onMounted(async () => {
  loadSolved();
  ids.value = await getAllGeoGuesserIds();
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("h1", null, "GeoGuesser", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ids.value, (id, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: id,
              cols: "4",
              sm: "2",
              md: "2",
              lg: "1",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  elevation: "2",
                  class: "pa-3",
                  hover: "",
                  onClick: ($event: any) => (openGuess(id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      size: "56",
                      class: "mx-auto",
                      color: isSolved(id) ? 'green-lighten-2' : 'grey-lighten-3'
                    }, {
                      default: _withCtx(() => [
                        (isSolved(id))
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "green-darken-3"
                            }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" mdi-check ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createElementVNode("div", _hoisted_1, "#" + _toDisplayString(index + 1), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})